import React, { useState } from 'react';
import { Table, Button, Modal, Form, Input, message, Space, Select } from 'antd';
import { EditOutlined, DeleteOutlined, PlusOutlined } from '@ant-design/icons';

const SmsTemplates = () => {
  const [isModalVisible, setIsModalVisible] = useState(false);
  const [form] = Form.useForm();
  const [templates, setTemplates] = useState([
    { id: 1, name: 'Hoş Geldin', content: 'Sayın {AD} {SOYAD}, spor okuluna hoş geldiniz!' },
    { id: 2, name: 'Hatırlatma', content: 'Sayın {AD} {SOYAD}, yarınki antrenmanınızı hatırlatırız.' },
  ]);

  const columns = [
    {
      title: 'Şablon Adı',
      dataIndex: 'name',
      key: 'name',
    },
    {
      title: 'İçerik',
      dataIndex: 'content',
      key: 'content',
    },
    {
      title: 'İşlemler',
      key: 'actions',
      render: (_, record) => (
        <Space>
          <Button 
            icon={<EditOutlined />} 
            onClick={() => handleEdit(record)}
          />
          <Button 
            icon={<DeleteOutlined />} 
            danger 
            onClick={() => handleDelete(record.id)}
          />
        </Space>
      ),
    },
  ];

  const handleEdit = (template) => {
    form.setFieldsValue(template);
    setIsModalVisible(true);
  };

  const handleDelete = (id) => {
    setTemplates(templates.filter(t => t.id !== id));
    message.success('Şablon silindi');
  };

  const handleSubmit = (values) => {
    if (values.id) {
      setTemplates(templates.map(t => t.id === values.id ? values : t));
    } else {
      setTemplates([...templates, { ...values, id: templates.length + 1 }]);
    }
    setIsModalVisible(false);
    form.resetFields();
    message.success('Şablon kaydedildi');
  };

  // Önce availableVariables'ı kategorilere ayıralım
  const variableCategories = {
    öğrenci: [
      { label: 'Ad', value: '{AD}' },
      { label: 'Soyad', value: '{SOYAD}' },
      { label: 'Öğrenci No', value: '{OGRENCI_NO}' },
      { label: 'Sınıf', value: '{SINIF}' },
    ],
    veli: [
      { label: 'Veli Adı', value: '{VELI_ADI}' },
      { label: 'Veli Telefon', value: '{VELI_TELEFON}' },
    ],
    okul: [
      { label: 'Okul Adı', value: '{OKUL_ADI}' },
      { label: 'Şube', value: '{SUBE}' },
    ]
  };

  // Değişken seçildiğinde şablon içeriğine ekleme yapacak fonksiyon
  const handleVariableSelect = (value) => {
    const contentField = form.getFieldValue('content') || '';
    form.setFieldsValue({
      content: contentField + value
    });
  };

  return (
    <div className="sms-templates">
      <div style={{ display: 'flex', justifyContent: 'space-between', marginBottom: 16 }}>
        <Button 
          type="primary" 
          icon={<PlusOutlined />}
          onClick={() => {
            form.resetFields();
            setIsModalVisible(true);
          }}
        >
          Yeni Şablon
        </Button>
      </div>

      <Table columns={columns} dataSource={templates} rowKey="id" />

      <Modal
        title="SMS Şablonu"
        open={isModalVisible}
        onOk={() => form.submit()}
        onCancel={() => setIsModalVisible(false)}
      >
        <Form
          form={form}
          layout="vertical"
          onFinish={handleSubmit}
        >
          <Form.Item name="id" hidden>
            <Input />
          </Form.Item>
          <Form.Item
            name="name"
            label="Şablon Adı"
            rules={[{ required: true, message: 'Lütfen şablon adı girin!' }]}
          >
            <Input />
          </Form.Item>
          <Form.Item
            label="Değişken Ekle"
            help="İçeriğe eklemek istediğiniz değişkeni seçin"
          >
            <div style={{ 
              border: '1px solid #d9d9d9', 
              borderRadius: '6px',
              padding: '12px',
              backgroundColor: '#fafafa'
            }}>
              {Object.entries(variableCategories).map(([category, variables]) => (
                <div key={category} style={{ marginBottom: '12px' }}>
                  <div style={{ 
                    fontWeight: 'bold', 
                    marginBottom: '8px',
                    color: '#666'
                  }}>
                    {category.toUpperCase()}:
                  </div>
                  <Space wrap>
                    {variables.map(variable => (
                      <Button
                        key={variable.value}
                        size="small"
                        onClick={() => handleVariableSelect(variable.value)}
                        icon={<PlusOutlined />}
                      >
                        {variable.label}
                      </Button>
                    ))}
                  </Space>
                </div>
              ))}
            </div>
          </Form.Item>
          <Form.Item
            name="content"
            label="Şablon İçeriği"
            rules={[{ required: true, message: 'Lütfen şablon içeriği girin!' }]}
          >
            <Input.TextArea 
              rows={4} 
              showCount 
              maxLength={160}
              placeholder="SMS içeriğini buraya yazın. Değişken eklemek için yukarıdaki butonları kullanabilirsiniz."
            />
          </Form.Item>
        </Form>
      </Modal>
    </div>
  );
};

export default SmsTemplates; 